module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    on: {
      "click": function($event) {
        _vm.countryListModel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Australia\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20b642a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=tqk19250jg!./~/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./src/components/WwfMenuCountryListBtn.vue
// module id = 658
// module chunks = 0